import { render, staticRenderFns } from "./ViewTeamUser.vue?vue&type=template&id=668472f8&scoped=true"
import script from "./ViewTeamUser.vue?vue&type=script&lang=js"
export * from "./ViewTeamUser.vue?vue&type=script&lang=js"
import style0 from "./ViewTeamUser.vue?vue&type=style&index=0&id=668472f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668472f8",
  null
  
)

export default component.exports